class SlideshowsComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');

    if (!this.slider) return;

    this.initPages();

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);
  }

  initPages() {
    const sliderActive = this.slider.id;
    const sliderID = this.slider.dataset.id;
    const sliderOptions = JSON.parse(this.slider.dataset.slick)

    console.log(sliderID)

    $('#' + sliderActive).not('.slick-initialized').slick({
      "appendDots": $('#sc-' + sliderID + " .thedots-before, #sc-" + sliderID + " .thedots-after"),
      ...sliderOptions,
      prevArrow: '<span class="prev-shadow"></span>',
      nextArrow: '<span class="slick-btn slick-next slick-arrow"><svg width="27" height="49" viewBox="0 0 27 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 47L24.5 24.5L2 2" stroke="#000000" stroke-width="3"/></svg></span>'

    });
    var activeClass = 'slick-active',
    ariaAttribute = 'aria-hidden';
    $( '#' + sliderActive )
    .on( 'init', function() {
        $( '.slick-dots li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, false );
    })
    .on( 'afterChange', function( event, slick, currentSlide, nextSlide ) {
      $.each(slick.$dots, (i, el) => {
        $(el).find('li').eq(currentSlide).addClass('slick-active');
      })
    });
  }
}

customElements.define('slideshows-component', SlideshowsComponent);

var $ = jQuery;

$(document).ready(function() {
  if($('#shopify-section-custom-image-banner5 .homepage-image').length) {
    $('#shopify-section-custom-image-banner5 .homepage-image').each(function() {
      var img_width = $(this).width();
      $(this).height((img_width * 9) / 16)
    })
  }
})